import { useTranslation } from '@pancakeswap/localization'
import { Route } from '@pancakeswap/smart-router/evm'
import { useModalV2 } from '@pancakeswap/uikit'
import { memo } from 'react'
import { useDebounce } from '@pancakeswap/hooks'
import SwapRoute from '@/views/Swap/components/SwapRoute'
import { RouteDisplayModal } from './RouteDisplayModal'
import { useWallchainStatus } from '../hooks/useWallchain'
import { RouteTooltip } from '@/components/tooltips/route'
import { Typography } from '@/components/ui/typography'

interface Props {
  routes?: Route[]
  isMM?: boolean
}

export const RoutesBreakdown = memo(function RoutesBreakdown({ routes = [], isMM }: Props) {
  const [wallchainStatus] = useWallchainStatus()
  const { t } = useTranslation()
  const routeDisplayModal = useModalV2()
  const deferWallchainStatus = useDebounce(wallchainStatus, 500)

  if (!routes.length) {
    return null
  }

  const count = routes.length

  return (
    <div className={'w-full pt-1'}>
      <div className={'flex items-center justify-between'}>
        <div className={'flex items-center gap-1'}>
          <Typography variant={'muted'}>
            {isMM ? t('MM Route') : deferWallchainStatus === 'found' ? t('Bonus Route') : t('Route')}
          </Typography>
          <RouteTooltip deferWallchainStatus={deferWallchainStatus} />
        </div>
        <button type={'button'} onClick={routeDisplayModal.onOpen}>
          <div>
            {count > 1 ? (
              <div className={'text-sm'}>{t('%count% Separate Routes', { count })}</div>
            ) : (
              <SwapRoute path={routes[0].path} />
            )}
          </div>
        </button>
        <RouteDisplayModal {...routeDisplayModal} routes={routes} />
      </div>
    </div>
  )
})
